export default {
    setLocations(state,payload){              
        state.locations = payload;
    },
    setTrendTweets(state, payload) {
        state.trendTweets = payload;
    },
    setConnectedAccounts(state, payload) {
        state.connectedTweetAccounts = payload;
    },
    setAuthorizeUrl(state, payload) {
        state.authorizeUrl = payload;
    }
}